import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Typography
} from '@mui/material';
import { t } from 'i18next';
import MultiSelectWithCheckbox from './MultiSelectWithCheckbox';

const ShuffleDialog = ({
  open,
  selectedItems = [],
  fromCategory,
  toCategory,
  fromItems = [],
  moveTocategories = [],
  setShuffleDialog,
  confirmShuffle,
  currentParent
}) => {
  const handleToggle = (id) => {
    setShuffleDialog((prev) => {
      const isSelected = prev.selectedItems.includes(id);
      const updated = isSelected
        ? prev.selectedItems.filter((i) => i !== id)
        : [...prev.selectedItems, id];
      return { ...prev, selectedItems: updated };
    });
  };

  const handleClose = () => {
    setShuffleDialog({
      open: false,
      fromCategory: '',
      selectedItems: [],
      toCategory: []
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{`Shuffle Items from ${currentParent?.value}`}</DialogTitle>
      <DialogContent dividers>
        <Box display="flex" gap={3}>
          <Box flex={1}>
            <Typography variant="subtitle2" component="h2" gutterBottom>
              {t('fieldManagement.selectItems')}
            </Typography>
            {fromItems?.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                {t('fieldManagement.noItemsToMove')}
              </Typography>
            ) : (
              <Stack spacing={1}>
                {fromItems?.map((item) => (
                  <FormControlLabel
                    key={item?.id}
                    control={
                      <Checkbox
                        checked={selectedItems.includes(item?.id)}
                        onChange={() => handleToggle(item?.id)}
                      />
                    }
                    label={item?.value}
                  />
                ))}
              </Stack>
            )}
          </Box>

          <Box flex={1}>
            <Typography variant="subtitle2" gutterBottom>
              {t('fieldManagement.moveTo')}
            </Typography>
            <MultiSelectWithCheckbox
              label="Move To"
              value={toCategory}
              onChange={(newToCategory) =>
                setShuffleDialog((prev) => ({ ...prev, toCategory: newToCategory }))
              }
              options={moveTocategories}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          {t('button.cancel')}
        </Button>
        <Button
          onClick={confirmShuffle}
          variant="contained"
          disabled={!toCategory || selectedItems.length === 0 || toCategory === fromCategory}>
          {t('button.move')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShuffleDialog;
